import { useDispatch } from 'react-redux'
import { errorActions } from '@/redux/actions'

export default function useDispatchRetry() {

	const dispatch = useDispatch()
	const dispatchAllowRetry = (action) => {
		dispatch(errorActions.actionAllowRetry(action))
	}
	return dispatchAllowRetry
}